export function canonicalRedirectTarget(current: { href: string }, canonicalUrl: string | undefined): string | null {
  if (!canonicalUrl) return null;
  let canonical: URL;
  let here: URL;
  try {
    canonical = new URL(canonicalUrl);
    here = new URL(current.href);
  } catch {
    return null;
  }
  if (here.origin === canonical.origin) return null;
  return `${canonical.origin}${here.pathname}${here.search}${here.hash}`;
}
